// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"AddPageDataModal_sectionTitle__3D7Ze","iconContainer":"AddPageDataModal_iconContainer__3YHpP"};